import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate, useParams, useLocation } from "react-router-dom";

import TopButton from "components/topbutton/TopButton";
import AttachFile from "components/AttachFile";
import * as EgovNet from 'api/fetch';

import ReactQuill from "react-quill-new";

import "styles/scss/NnewDetail.scss";

const NewsDetail = () => {
    const navigate = useNavigate();
    const [news, setNews] = useState([]);
    const [html, setHtml] = useState([]);
    const [files, setFiles] = useState([]);

    const location = useLocation(); // useLocation 훅을 사용하여 현재 위치 정보 가져오기
    const { activeTab } = location.state || {};

    //목록 버튼 이동
    const handleButtonClick = () => {
        navigate('/news', { state: { activeTab } });
    };

    const [isCompanyDropdownOpen, setIsCompanyDropdownOpen] = useState(false);
    const { id } = useParams(); // URL 파라미터로 ID 가져오기

    useEffect(() => {
        retrieveList();
    }, []);

    const retrieveList = () => {
        const retrieveListURL = `/api/view/${id}`;
        const requestOptions = {
            method: "GET",
            headers: {
                'Content-type': 'application/json',
            }
        }
        EgovNet.requestFetch(retrieveListURL,
            requestOptions,
            (resp) => {
                setNews(resp.result.news);
                setHtml(resp.result.news.pstCn); // content 상태를 업데이트합니다.
                // 가져온 파일 배열 세팅
                setFiles(resp.result.files); // 파일 이름을 배열로 설정합니다.
            },
            (resp) => {
                console.log("err response : ", resp);
            }
        );
    };

    const viewModeModules = {
        toolbar: false,
    };

    // 날짜 연월일 시:분 형식으로 변경하는 함수
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}`;
    };
    
    return (
        <>
        <div className="news-background">
        <TopButton />
            <h1>N 소식</h1>
            <p>[ 소식 / 보도자료 / 갤러리 ]</p>
            {/* 브레드크럼 */}
            <div className="breadcrumb-box container">
            <nav className="breadcrumb">
                <ul>
                    <li className="home-icon">
                    <Link to="/">
                        <span className="home"></span>
                    </Link>
                    </li>
                    <li className="dropdown" onClick={() => setIsCompanyDropdownOpen(!isCompanyDropdownOpen)}>
                        N소식
                        <span className="dropdown-icon">
                        {isCompanyDropdownOpen ? "▲" : "▼"}
                        </span>
                        {isCompanyDropdownOpen && (
                            <ul className="dropdown-menu">
                                <li>
                                    <Link to="/about">회사소개</Link>
                                </li>
                                <li>
                                    <Link to="/business">비즈니스</Link>
                                </li>
                                <li>
                                    <Link to="/news">N소식</Link>
                                </li>
                                <li>
                                    <Link to="/recruitment">인재채용</Link>
                                </li>
                            </ul>
                        )}
                    </li>
                </ul>
            </nav>

            <div className="mobile">
                <ul>
                    <li className="home-icon">
                        <Link to="/">
                            <span className="home"></span>
                        </Link>
                    </li>
                    <li className="dropdown" onClick={() => setIsCompanyDropdownOpen(!isCompanyDropdownOpen)}>
                        N소식
                        <span className="dropdown-icon">
                        {isCompanyDropdownOpen ? "▲" : "▼"}
                        </span>
                        {isCompanyDropdownOpen && (
                        <ul className="dropdown-menu">
                            <li>
                                <Link to="/about">회사소개</Link>
                            </li>
                            <li>
                                <Link to="/business">비즈니스</Link>
                            </li>
                            <li>
                                <Link to="/news">N소식</Link>
                            </li>
                            <li>
                                <Link to="/recruitment">인재채용</Link>
                            </li>
                        </ul>
                        )}
                    </li>
                </ul>
            </div>
            </div>
        </div>


    {/* N소식 상세보기 콘텐츠 */}
    <div className="container newDetail-box">
      <ul>
        <li className="con-name-box">
          <span className="con-name">{news.ctgryNm}</span>
        </li>
        <li className='tit'>
          <h3 className="sub-tit">{news.pstTtl}</h3>
          <div className="day-box">
            <span>{formatDate(news.regDt)}</span>
          </div>
          <p>
            {news.expln}
          </p>
        </li>
        <div className="newDetail-img">
            <ReactQuill
                modules={viewModeModules}
                value={html || ''}
            />
        </div>
        {Array.isArray(files) && files.length > 0 &&
        <div className="file-box">
            <span className="file-tit">첨부파일</span> 
            <AttachFile boardFiles={files} />
        </div>
        }
        <li>
            <div>
                <button type="button" className="btn btn-list" onClick={handleButtonClick}>목록</button>
            </div>
        </li>
      </ul>
    </div>

        </>
    );
}

export default NewsDetail;